document.addEventListener("DOMContentLoaded", function () {
    if (window.matchMedia("(min-width: 990px)").matches) {
    }
    initCards();


    gsap.set('.co-os-s6-img.z-ani-o', { opacity: 0, y: 20, x: 5 });
    gsap.set('.co-os-s6-text .z-ani-o', { opacity: 0, y: 40 });
    let cOsS5Tl1 = gsap.timeline({ paused: true });
    cOsS5Tl1.to('.co-os-s6-img.z-ani-o', {
        y: 0,
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
    });
    cOsS5Tl1.to('.co-os-s6-text .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-os-s6-text .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cOsS5Tl1
    });


});


//CARDS SCROLL

const contentElements = [...document.querySelectorAll('.co-os-s6-frame')];
const totalContentElements = contentElements.length;

const scrollCards = () => {
    contentElements.forEach((el, position) => {

        const isLast = position === totalContentElements - 1;

        gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'center center',
                end: '+=150%',
                scrub: true
            }
        })
            .to(el, {
                ease: 'none',
                scale: 0.9,
                opacity: 1,
                yPercent: 0
            }, 0);

    });
};

// Initialization function
const initCards = () => {
    scrollCards(); // Apply scroll-triggered animations
};